/*
  SAGÓ · secciones propias.

  <sago-carrusel>: las flechas deslizan la pista de tarjetas una pantalla y se
  apagan cuando ya no queda recorrido. Sin flechas (o sin JavaScript), la pista
  se desliza igual con el dedo o con la rueda.

  Creado el 11/10/2026.
*/
if (!customElements.get('sago-carrusel')) {
  customElements.define(
    'sago-carrusel',
    class SagoCarrusel extends HTMLElement {
      connectedCallback() {
        this.pista = this.querySelector('.sago-carrusel__pista');
        this.flechas = this.querySelectorAll('.sago-carrusel__flecha');
        if (!this.pista) return;

        this.flechas.forEach((flecha) => {
          flecha.addEventListener('click', () => this.mover(Number(flecha.dataset.dir)));
        });
        this.pista.addEventListener('scroll', () => this.revisar(), { passive: true });
        this.observador = new ResizeObserver(() => this.revisar());
        this.observador.observe(this.pista);
        this.revisar();
      }

      disconnectedCallback() {
        if (this.observador) this.observador.disconnect();
      }

      mover(direccion) {
        const tarjeta = this.pista.firstElementChild;
        if (!tarjeta) return;
        const hueco = parseFloat(getComputedStyle(this.pista).columnGap) || 0;
        const paso = tarjeta.getBoundingClientRect().width + hueco;
        const cuantas = Math.max(1, Math.floor(this.pista.clientWidth / paso));
        const suave = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.pista.scrollBy({ left: direccion * paso * cuantas, behavior: suave ? 'smooth' : 'auto' });
      }

      revisar() {
        const recorrido = this.pista.scrollWidth - this.pista.clientWidth;
        this.toggleAttribute('data-cabe', recorrido <= 2);
        this.flechas.forEach((flecha) => {
          const haciaAtras = Number(flecha.dataset.dir) < 0;
          flecha.disabled = haciaAtras ? this.pista.scrollLeft <= 2 : this.pista.scrollLeft >= recorrido - 2;
        });
      }
    }
  );
}
